import { render } from "./HeaderPC.vue?vue&type=template&id=5eb3cc24&scoped=true"
import script from "./HeaderPC.vue?vue&type=script&lang=js"
export * from "./HeaderPC.vue?vue&type=script&lang=js"

import "./HeaderPC.vue?vue&type=style&index=0&id=5eb3cc24&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5eb3cc24"

export default script